var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2969_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 0C4.54076 0 4.69973 0.065848 4.81694 0.183058C4.93415 0.300269 5 0.45924 5 0.625V1.25H15V0.625C15 0.45924 15.0658 0.300269 15.1831 0.183058C15.3003 0.065848 15.4592 0 15.625 0C15.7908 0 15.9497 0.065848 16.0669 0.183058C16.1842 0.300269 16.25 0.45924 16.25 0.625V1.25H17.5C18.163 1.25 18.7989 1.51339 19.2678 1.98223C19.7366 2.45107 20 3.08696 20 3.75V17.5C20 18.163 19.7366 18.7989 19.2678 19.2678C18.7989 19.7366 18.163 20 17.5 20H2.5C1.83696 20 1.20107 19.7366 0.732233 19.2678C0.263392 18.7989 0 18.163 0 17.5V3.75C0 3.08696 0.263392 2.45107 0.732233 1.98223C1.20107 1.51339 1.83696 1.25 2.5 1.25H3.75V0.625C3.75 0.45924 3.81585 0.300269 3.93306 0.183058C4.05027 0.065848 4.20924 0 4.375 0ZM2.5 2.5C2.16848 2.5 1.85054 2.6317 1.61612 2.86612C1.3817 3.10054 1.25 3.41848 1.25 3.75V17.5C1.25 17.8315 1.3817 18.1495 1.61612 18.3839C1.85054 18.6183 2.16848 18.75 2.5 18.75H17.5C17.8315 18.75 18.1495 18.6183 18.3839 18.3839C18.6183 18.1495 18.75 17.8315 18.75 17.5V3.75C18.75 3.41848 18.6183 3.10054 18.3839 2.86612C18.1495 2.6317 17.8315 2.5 17.5 2.5H2.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5C3.125 4.83424 3.19085 4.67527 3.30806 4.55806C3.42527 4.44085 3.58424 4.375 3.75 4.375H16.25C16.4158 4.375 16.5747 4.44085 16.6919 4.55806C16.8092 4.67527 16.875 4.83424 16.875 5V6.25C16.875 6.41576 16.8092 6.57473 16.6919 6.69194C16.5747 6.80915 16.4158 6.875 16.25 6.875H3.75C3.58424 6.875 3.42527 6.80915 3.30806 6.69194C3.19085 6.57473 3.125 6.41576 3.125 6.25V5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2969_1224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar1);
export default ForwardRef;